import { GroupForm } from './GroupForm';

export type { TypeGroupFormProps } from './types';
export default GroupForm;
